import { memo } from 'react'
import { ReloadProtectedApp } from './ReloadProtectedApp'

export const MemoizedRemoteApp = memo(ReloadProtectedApp)
